/* istanbul ignore file: ui-tpa missing content type testkit support */
import {useGlobals} from '../../../../../../../globalPropsContext';
import {ButtonContentType} from '../../../../../../../types/galleryTypes';

export const useProductQuickAddAddToCartButtonType = () => {
  const {styles, stylesParams} = useGlobals();
  const contentType = styles.get(stylesParams.gallery_addToCartButtonContentType);

  switch (contentType) {
    case ButtonContentType.IconAndText:
      return ButtonContentType.IconAndText;
    case ButtonContentType.Text:
      return ButtonContentType.Text;
    case ButtonContentType.Icon:
      return ButtonContentType.Text;
  }
};
